import { render, staticRenderFns } from "./AirlineMenus.vue?vue&type=template&id=398d8f2d&"
import script from "./AirlineMenus.vue?vue&type=script&lang=js&"
export * from "./AirlineMenus.vue?vue&type=script&lang=js&"
import style0 from "./AirlineMenus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports